import { useState, useRef} from 'react';
import Head from "next/head";
import Form1 from '../components/programs/Form1';
import Form2 from '../components/programs/Form2';
import Form3 from '../components/programs/Form3';
import Form4 from '../components/programs/Form4';
import Form5 from '../components/programs/Form5';
import Form6 from '../components/programs/Form6';
import Success from '../components/programs/Success';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import axios from 'axios';
import { baseUrl } from '../utils/urls';

const ChooseProgram = () => {
  const splide = useRef(null);
  const [ formState, setFormState ] = useState({});
  const [ formStep, setFormStep ] = useState(0);
  const [ loading, setLoading ] = useState(false);
  const successStep = 6;
  const failureStep = 7;


  const prevStep = () => {
    splide.current.splide.go(formStep - 1);
    setFormStep(formStep - 1);
  }

  const nextStep = () => { 
    splide.current.splide.go(formStep + 1);
    setFormStep(formStep + 1) 
  };

  const jumpToStep = (step) => { 
    splide.current.splide.go(step);
    if(step > formStep+1){
      return;
    } else {
      setFormStep(step);
    }
  };

  const submitHandler = async () => {
    try{
      const url = baseUrl + '/api/v1/program_reaches/';
      setLoading(true);
      await axios.post(url, formState);
      setFormState({});
      setLoading(false);
      jumpToStep(successStep);
    } catch(err) {
      setLoading(false);
      jumpToStep(failureStep);
    }
  }

  const changeHandler = (data) => {
    setFormState({...formState, ...data})
  }

  return (
    <div className="transformationStories">
      <Head>
        <meta property="og:image" content={"https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"} />
        <title>Choose Program || Optimum Wellness</title>
      </Head>
      
      <h1 className="fo-34 fw-700 text-center mt-md-5 mb-md-5 mfo-22 p-3 p-md-0">
      Find out which program is right for you
      </h1>

      <StepTracker step={formStep} jumpToStep={jumpToStep}/>
      <Splide ref={splide} options={{
        arrows: false,
        drag: false,
        pagination: false,
      }}>
        <SplideSlide>
          <Form1 state={formState} changeHandler={changeHandler} nextHandler={nextStep} prevHandler={prevStep}/>
        </SplideSlide>
        <SplideSlide>
          <Form2 state={formState} changeHandler={changeHandler} nextHandler={nextStep} prevHandler={prevStep}/>
        </SplideSlide>
        <SplideSlide>
          <Form3 state={formState} changeHandler={changeHandler} nextHandler={nextStep} prevHandler={prevStep}/>
        </SplideSlide>
        <SplideSlide>
          <Form4 state={formState} changeHandler={changeHandler} nextHandler={nextStep} prevHandler={prevStep}/>
        </SplideSlide>
        <SplideSlide>
          <Form5 state={formState} changeHandler={changeHandler} nextHandler={nextStep} prevHandler={prevStep}/>
        </SplideSlide>
        <SplideSlide>
          <Form6 state={formState} changeHandler={changeHandler} submitHandler={submitHandler} prevHandler={prevStep} loading={loading}/>
        </SplideSlide>
        <SplideSlide>
          <Success />
        </SplideSlide>
      </Splide>
    </div>
  );
};

export default ChooseProgram;

const StepTracker = ({ jumpToStep, step }) => {
  return(
    <div className="workflowToggleSection mt-4 programFlowSection">
    { [1,2,3,4,5,6].map(i => {
      const clickHandler = () => {
        if(i-1 <= step){
          jumpToStep(i-1);
        }
      };
      return(
        <div key={i} onClick={clickHandler}>
          { i != 0 && (<div className=""></div>)}
        <div className={ `workflowToggleDiv cursorPointer ${i-1 <= step || i == 1 ? 'active' : 'false'}` }>
        <div className="fo-20 fw-700 mfo-14" >{i}</div>
          </div>
        </div>
      )
    }) }
  </div>
  )
}
